// extracted by mini-css-extract-plugin
export default {"common_logo":"Logo_common_logo__dWPnO","icon":"Logo_icon__+V6Nn"};